import { PageHeader } from "components";
import { NextPage } from "next";
import {
  CareerHeaderSection,
  JobsListSection,
  NewsletterSection,
} from "sections";
import { IJobsV3Fields, IStaticNewsletterSectionFields } from "types";
import { getContentfulEntries } from "../../utils/contentful-api";

const Career: NextPage<{
  newsletter: IStaticNewsletterSectionFields[];
  jobs: IJobsV3Fields[];
}> = ({ newsletter, jobs }) => {
  return (
    <div>
      <PageHeader title="Career" />
      <CareerHeaderSection />
      <JobsListSection jobs={jobs} />
      <NewsletterSection newsletterSection={newsletter} />
    </div>
  );
};

export default Career;

export async function getStaticProps() {
  const newsletter = await getContentfulEntries<IStaticNewsletterSectionFields>(
    "newsletterSection"
  );

  const jobs = await getContentfulEntries<IJobsV3Fields>("jobsV3");

  return {
    props: {
      newsletter,
      jobs,
    },
    revalidate: 3600, // Revalidate every hour
  };
}
